import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/menu",
      name: "menu",
      component: () => import("./views/Menu.vue")
    },
    {
      path: "/ziyuanpinggu",
      name: "ziyuanpinggu",
      component: () => import("./views/ZiyuanPinggu.vue")
    },
    {
      path: "/spotrealtime",
      name: "spotrealtime",
      component: () => import("./views/SpotRealtime.vue")
    },
    {
      path: "/spotpasttime",
      name: "spotpasttime",
      component: () => import("./views/SpotPasttime.vue")
    },
    {
      path: "/home/shengneiremenluxian",
      name: "remenluxian",
      component: () => import("./views/ShengneiRemenLuxian.vue")
    },
    {
      path: "/home/youkelaiyuan",
      name: "youkelaiyuan",
      component: () => import("./views/YoukeLaiyuan.vue")
    },
    {
      path: "/home/zhusuretu",
      name: "zhusuretu",
      component: () => import("./views/ZhusuRetu.vue")
    },
    {
      path: "/juminchuyou",
      name: "juminchuyou",
      component: () => import("./views/JuminChuyou.vue")
    },
    {
      path: "/juminchuyou/chuyoumudidifenxi",
      name: "chuyoumudidifenxi",
      component: () => import("./views/ChuyouMudidi.vue")
    },
    {
      path: "/juminchuyou/chuyouremenluxian",
      name: "chuyouremenluxian",
      component: () => import("./views/ChuyouRemenLuxian.vue")
    },
    {
      path: "/jingqukoubei",
      name: "jingqukoubei",
      component: () => import("./views/JingquKoubei.vue")
    },
    {
      path: "/scenicjingqukoubei",
      name: "scenicjingqukoubei",
      component: () => import("./views/ScenicJingquKoubei.vue")
    },
    {
      path: "/lvyouyulun",
      name: "lvyouyulun",
      component: () => import("./views/Lvyouyulun.vue")
    }
  ]
});
